module.exports = __webpack_public_path__ + "static/media/sliit-logoo.8c540fc1.png";